import React, { Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL, baseURL_Radio_Compaign } from '../../_helpers';
import { TOKEN } from '../../_helpers/token';
import * as moment from 'moment';
import { Link } from 'react-router-dom';

export class DepositRequests_CustomerDeposits extends React.Component {
    constructor(props) {
        super(props);


        this.columns = [

            {
                key: "reference",
                TrOnlyClassName: 'tsc',
                text: "Reference",
                className: "tsc",
                align: "left"
            },
            {
                key: "amount",
                TrOnlyClassName: 'tsc',
                text: "Amount",
                className: "tsc",
                align: "left"
            },
            {
                key: "status",
                TrOnlyClassName: 'tsc',
                text: "Status",
                className: "tsc",
                align: "left"
            },

            {
                key: "phone",
                TrOnlyClassName: 'tsc',
                text: "Phone Numnber",
                className: "tsc",
                align: "left"
            },
            {
                key: "mail",
                TrOnlyClassName: 'tsc',
                text: "Email",
                className: "tsc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "Date Created",
                className: "tsc",
                align: "left"
            },
            {
                key: "action",
                text: "Blacklist?",
                TrOnlyClassName: 'cell',
                className: "cell",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center" >
                            <button className=" btn-primary"
                                title="Blacklist?"
                                style={
                                    { marginRight: '10px' }}
                                onClick={
                                    () => {
                                        if (window.confirm('Are you sure you want to send this request?'))
                                            this.onSubmitblacklist(record)
                                    }
                                } >
                                <span className="" > MTN Deposit Enquiry </span>
                            </button>

                        </Fragment>
                    );
                }
            }
        ];



        this.config = {
            key_column: "tsc",
            length_menu: [100, 200, 500],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter Phone/Email...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }

        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
    }



    onSubmitblacklist(record) {

        var sha512 = require('js-sha512');

        // alert(JSON.stringify(record))

        // alert(baseURL_Radio_Compaign + 'mtn_deposit_enquiry/' + record.transactionId)

        let signature = sha512('P@s5w0rd_5@lt' + record.reference)


        axios.get(baseURL_Radio_Compaign + `mtn_deposit_enquiry/${record.reference}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "signature": signature
            },
        }).then((response) => {
            if (response.data.code == "0000") {
                alert(response.data.message)
            } else {
                alert(response.data.message);
                this.setState({ isShowError: true, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({ isShowError: true, isLoading: false });
            alert(error.response.data.message)
        });

    }


    componentDidMount() {
        this.getData();
    }

    getData = (queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        // eslint-disable-next-line
        let url = baseURL + "mtndeposits?" + "filter_value=" + localStorage.getItem("phone_id") + "&page_number=1&page_size=10&sort_order=false"
        console.log("query", url);
        console.log("token", TOKEN)
        axios.all([
            axios.get(url, axiosConfig)
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data.data,
                isLoading: false,
            },
                function () {
                    var data = [];
                    console.log("BUG", branchResponse.data)
                    if (this.state.admins.length > 0) {

                        this.setState({
                            total: branchResponse.data.total
                        })
                        for (let i = 0; i < (this.state.admins.length || 0); i++) {

                            let mail;
                            let mbalance;
                            let phone;

                            if (this.state.admins[i].email == null) {
                                mail = { mail: "_" };
                            } else {
                                mail = { mail: this.state.admins[i].email };
                            }


                            if (this.state.admins[i].msisdn === null) {
                                phone = { phone: "_" };
                            } else {
                                phone = { phone: this.state.admins[i].msisdn };
                            }

                            if (this.state.admins[i].balance === 0) {
                                mbalance = { mbalance: "0.0" };
                            } else {
                                mbalance = { mbalance: this.state.admins[i].balance };
                            }

                            let date = { dates: moment.utc(this.state.admins[i].time).format('DD, MMM YYYY HH:mm:ss') };
                            data.push(Object.assign(date, phone, mail, mbalance, this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                    }
                }
            );
        }))

    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }


    render() {
        return (
            <div >
                < >
                    < Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >
                                    <div className="row">
                                        <div className="col-6">
                                            <h4>Deposit Requests ({localStorage.getItem("phone")})</h4><br />
                                        </div>
                                        <div className="col-md-6">
                                            <Link to="/userdetail">
                                                <Button className="float-right"
                                                    color="primary" outline><i className="fa  fa-arrow-left"></i> Back</Button><br /> <br /><br />
                                            </Link>
                                        </div>
                                    </div>
                                    <br />
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </CardBody>

                        </Card>
                    </Col>
                </>
            </div>
        )
    }
}